// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oh-1";
export var stateContainer = "_oh-0";